module.exports = __webpack_public_path__ + "img/5.1a225ef5.jpg";